import { render, staticRenderFns } from "./payForDetails.vue?vue&type=template&id=c65d51f2&scoped=true"
import script from "./payForDetails.vue?vue&type=script&lang=js"
export * from "./payForDetails.vue?vue&type=script&lang=js"
import style0 from "./payForDetails.vue?vue&type=style&index=0&id=c65d51f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65d51f2",
  null
  
)

export default component.exports